"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castel-sant-angelo": {
    "202d497b": [{
      "hkey": "671196a1",
      "slug": "castel-sant-angelo",
      "name": "Castel Sant'Angelo",
      "primary": true,
      "skipSearch": false
    }],
    "canetra": [{
      "hkey": "671196a1",
      "slug": "castel-sant-angelo",
      "name": "Castel Sant'Angelo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e09b95a5": [{
      "hkey": "c5540336",
      "slug": "mozza-villa-ornaro",
      "name": "Mozza-Villa Ornaro",
      "primary": true,
      "skipSearch": false
    }],
    "mozza": [{
      "hkey": "c5540336",
      "slug": "mozza-villa-ornaro",
      "name": "Mozza-Villa Ornaro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2707a331": [{
      "hkey": "671196a1",
      "slug": "castel-sant-angelo",
      "name": "Castel Sant'Angelo",
      "primary": true,
      "skipSearch": false
    }],
    "pagliara": [{
      "hkey": "671196a1",
      "slug": "castel-sant-angelo",
      "name": "Castel Sant'Angelo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4697fdf6": [{
      "hkey": "671196a1",
      "slug": "castel-sant-angelo",
      "name": "Castel Sant'Angelo",
      "primary": true,
      "skipSearch": false
    }],
    "piedimozza": [{
      "hkey": "671196a1",
      "slug": "castel-sant-angelo",
      "name": "Castel Sant'Angelo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d7150b57": [{
      "hkey": "671196a1",
      "slug": "castel-sant-angelo",
      "name": "Castel Sant'Angelo",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-alto": [{
      "hkey": "671196a1",
      "slug": "castel-sant-angelo",
      "name": "Castel Sant'Angelo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4767ee7e": [{
      "hkey": "671196a1",
      "slug": "castel-sant-angelo",
      "name": "Castel Sant'Angelo",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-santa-margherita": [{
      "hkey": "671196a1",
      "slug": "castel-sant-angelo",
      "name": "Castel Sant'Angelo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7a88a68d": [{
      "hkey": "4c558e17",
      "slug": "terme-di-cotilia",
      "name": "Terme di Cotilia",
      "primary": true,
      "skipSearch": false
    }],
    "terme-di-cotilla": [{
      "hkey": "4c558e17",
      "slug": "terme-di-cotilia",
      "name": "Terme di Cotilia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;